// extracted by css-extract-rspack-plugin
export default {"chatikSpoiler":"chatik_spoiler--nab5FSTnaVg7yjk2","loader":"loader--MmkjKn8bXYpYO2hX"};